import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup, FormArray} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

//Curva de um canal no formato do motor:
//  { type:'BEZIER', scale:1, bezierPoints:[ {x,y,percentage}, ... ] }
export function defaultBezierPoints(){
  return [
    {x:0,y:1,percentage:0},
    {x:0,y:0,percentage:1}
  ];
}
//Preset "fogo": conjunto de referencia do motor de particulas.
export function fireParam(){
  return {
    maxParticles:300,
    duration:5,
    looping:true,

    startLifetime:{min:0.6,max:1.4},
    startSpeed:{min:0.6,max:1.6},
    startSize:{min:0.5,max:1.1},
    startRotation:{min:0,max:360},

    startColor:{
      min:{r:1,g:0.85,b:0.2},
      max:{r:1,g:0.4,b:0}
    },

    colorOverLifetime:{
      isActive:true,
      r:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:1,percentage:0},
        {x:0,y:0.9,percentage:0.3},
        {x:0,y:0.35,percentage:0.65},
        {x:0,y:0,percentage:1}
      ]},
      g:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:0.7,percentage:0},
        {x:0,y:0.5,percentage:0.3},
        {x:0,y:0.1,percentage:0.65},
        {x:0,y:0,percentage:1}
      ]},
      b:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:0,percentage:0},
        {x:0,y:0,percentage:1}
      ]}
    },

    sizeOverLifetime:{
      isActive:true,
      size:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:0.35,percentage:0},
        {x:0,y:1,percentage:0.4},
        {x:0,y:0.1,percentage:1}
      ]}
    },

    opacityOverLifetime:{
      isActive:true,
      opacity:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:0,percentage:0},
        {x:0,y:1,percentage:0.15},
        {x:0,y:0,percentage:1}
      ]}
    },

    emission:{rateOverTime:90},
    gravity:1.2,
    simulationSpace:'WORLD',

    shape:{shape:'CONE',cone:{angle:0.25,radius:0.15}},

    noise:{isActive:true,strength:0.6,frequency:1.2,scrollSpeed:1.5,octaves:2},

    renderer:{
      rendererType:'INSTANCED',
      blending:'additive',
      transparent:true,
      depthWrite:false,
      texture:'assets/particles/textures/flame.webp'
    }
  };
}
//Texturas de particula embutidas (baixadas de NewKrok/three-particles-editor,
//licenca MIT). tiles = spritesheet no formato [colunas, linhas]; ausente = textura unica.
export function builtinParticleTextures(){
  const T=[
    ['point',1,1],['gradient-point',1,1],['circle',1,1],['cloud',1,1],
    ['flame',1,1],['flare',1,1],['star',1,1],['star-toon',1,1],
    ['plus',1,1],['plus-toon',1,1],['moon',1,1],['raindrop',1,1],
    ['leaf-toon',1,1],['snowflake',1,1],['snowflake-detailed',1,1],
    ['numbers',5,2],['numbers-toon',5,2],['confetti',5,2],['confetti-toon',5,2],
    ['magic-explosion',5,2],['feather',1,1],['skull',1,1],['heart',1,1],
    ['square',1,1],['rocks',5,2],['light-streak',1,1],['radial-brust',1,1],
    ['starbust',1,1],['soft-smoke',1,1],['vortex',1,1],['bubbles',1,1]
  ];
  let list=[];
  T.forEach(row=>{
    let name=row[0];
    let tx=row[1];
    let ty=row[2];
    let item:any={
      id:name,
      name:name,
      url:'assets/particles/textures/'+name+'.webp'
    };
    if (tx>1 || ty>1){
      item.tiles=[tx,ty];
    }
    list.push(item);
  })
  return list;
}
//Preset "fumaca".
export function smokeParam(){
  return {
    maxParticles:400,
    duration:8,
    looping:true,

    startLifetime:{min:3.0,max:6.0},
    startSpeed:{min:0.15,max:0.5},
    startSize:{min:0.8,max:1.8},
    startRotation:{min:0,max:360},

    startColor:{
      min:{r:0.22,g:0.22,b:0.24},
      max:{r:0.42,g:0.42,b:0.45}
    },

    colorOverLifetime:{
      isActive:true,
      r:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:1,percentage:0},
        {x:0,y:0.6,percentage:1}
      ]},
      g:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:1,percentage:0},
        {x:0,y:0.6,percentage:1}
      ]},
      b:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:1,percentage:0},
        {x:0,y:0.6,percentage:1}
      ]}
    },

    sizeOverLifetime:{
      isActive:true,
      size:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:0.25,percentage:0},
        {x:0,y:1,percentage:1}
      ]}
    },

    opacityOverLifetime:{
      isActive:true,
      opacity:{type:'BEZIER',scale:1,bezierPoints:[
        {x:0,y:0,percentage:0},
        {x:0,y:0.35,percentage:0.2},
        {x:0,y:0.25,percentage:0.7},
        {x:0,y:0,percentage:1}
      ]}
    },

    emission:{rateOverTime:60},
    gravity:0.25,
    simulationSpace:'WORLD',

    shape:{shape:'CONE',cone:{angle:0.7,radius:0.35}},

    rotationOverLifetime:{
      isActive:true,
      angularVelocity:{min:-25,max:25}
    },

    noise:{isActive:true,strength:1.2,frequency:0.6,scrollSpeed:0.8,octaves:3},

    renderer:{
      rendererType:'INSTANCED',
      blending:'normal',
      transparent:true,
      depthWrite:false,
      texture:'assets/particles/textures/cloud.webp'
    }
  };
}
//Presets disponiveis no editor. Para adicionar outro, basta criar uma funcao como
//fireParam()/smokeParam() e registrar aqui com um novo id/name.
export function particlePresets(){
  return [
    {id:'fire',name:'Fogo',param:fireParam()},
    {id:'smoke',name:'Fumaça',param:smokeParam()}
  ];
}
//Valores iniciais (preset de fogo) + o que e proprio da acao.
export function defaultParticleParam(){
  let param:any=fireParam();
  //modulo que o preset de fogo nao usa, mas que o editor precisa cobrir
  param.rotationOverLifetime={isActive:false,angularVelocity:{min:0,max:0}};
  param.url=[];
  param.text='';
  param.closeness=0;
  param.density=1;
  return param;
}

@Component({
    selector : 'particles-action',
    templateUrl:'particles.html'
})
export class ParticlesActionComponent extends BaseActionComponent{

  public itemVideos;
  public media
  public linkForm: FormGroup;
  public onClickAction=false;
  public text=''
  public level=1;
  public order=0;
  //limites de closeness/density
  public readonly CLOSENESS_MIN=0;
  public readonly CLOSENESS_MAX=1;
  public readonly DENSITY_MIN=0.1;
  public readonly DENSITY_MAX=10;
  //limites das demais propriedades numericas
  public readonly MAX_PARTICLES_MIN=0;
  public readonly MAX_PARTICLES_MAX=20000;
  public readonly DURATION_MIN=0.1;
  public readonly DURATION_MAX=600;
  public readonly RATE_MIN=0;
  public readonly RATE_MAX=5000;
  public readonly GRAVITY_MIN=-50;
  public readonly GRAVITY_MAX=50;
  public readonly SPEED_MIN=0;
  public readonly SPEED_MAX=100;
  public readonly SIZE_MIN=0;
  public readonly SIZE_MAX=100;
  public readonly LIFETIME_MIN=0.01;
  public readonly LIFETIME_MAX=120;
  public readonly ANGLE_MIN=0;
  public readonly ANGLE_MAX=360;
  public readonly RADIUS_MIN=0;
  public readonly RADIUS_MAX=100;
  public readonly CONE_ANGLE_MIN=0;
  public readonly CONE_ANGLE_MAX=3.1416;
  public readonly NOISE_STRENGTH_MIN=0;
  public readonly NOISE_STRENGTH_MAX=20;
  public readonly NOISE_FREQUENCY_MIN=0.01;
  public readonly NOISE_FREQUENCY_MAX=100;
  public readonly SCROLL_SPEED_MIN=-100;
  public readonly SCROLL_SPEED_MAX=100;
  public readonly OCTAVES_MIN=1;
  public readonly OCTAVES_MAX=8;
  public readonly ANGULAR_VELOCITY_MIN=-3600;
  public readonly ANGULAR_VELOCITY_MAX=3600;

  public simulationSpaces=[
    {name:'WORLD',kind:'WORLD'},
    {name:'LOCAL',kind:'LOCAL'}
  ];
  public shapes=[
    {name:'CONE',kind:'CONE'},
    {name:'SPHERE',kind:'SPHERE'},
    {name:'BOX',kind:'BOX'},
    {name:'CIRCLE',kind:'CIRCLE'},
    {name:'HEMISPHERE',kind:'HEMISPHERE'}
  ];
  public rendererTypes=[
    {name:'INSTANCED',kind:'INSTANCED'},
    {name:'MESH',kind:'MESH'},
    {name:'BILLBOARD',kind:'BILLBOARD'},
    {name:'STRETCHED_BILLBOARD',kind:'STRETCHED_BILLBOARD'}
  ];
  public blendings=[
    {name:'additive',kind:'additive'},
    {name:'normal',kind:'normal'},
    {name:'multiply',kind:'multiply'},
    {name:'subtractive',kind:'subtractive'}
  ];
  public curveKeys=[{key:'r',label:'R'},{key:'g',label:'G'},{key:'b',label:'B'}];

  //presets prontos (fogo hoje; a lista vem de particlePresets())
  public presets:any[]=particlePresets();
  public presetSelect='';

  //texturas do renderer
  public particleTextures:any[]=builtinParticleTextures();
  public roomIcons:any[]=[];
  public selectedTextureId='';
  public showIcons=false;

  //pontos das curvas materializados em propriedades estaveis: se fossem lidos do
  //formulario direto no template, cada ciclo de deteccao criaria um array novo e
  //o editor de curvas se redesenharia sem parar.
  public colorCurves:any={r:[],g:[],b:[]};
  public sizeCurve:any[]=[];
  public opacityCurve:any[]=[];

  //param salvo, usado para preservar type/scale das curvas ao gravar
  public lastParam=null;

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
    this.linkForm = this.buildForm(defaultParticleParam());
    //se o usuario mudar qualquer campo, o preset deixa de corresponder
    this.linkForm.valueChanges.subscribe(v=>{
      if (this.loadingForm){
        return;
      }
      this.refreshPresetSelection();
    });
  }
  //evita reentrancia enquanto o form e reconstruido
  public loadingForm=false;

  /////////////////////////////////////////////////////////////////////
  // PRESETS
  /////////////////////////////////////////////////////////////////////
  public selectPreset(id){
    this.presetSelect=id;
    if (!id){
      return;
    }
    this.applyPreset(id);
  }
  //seta todos os parametros do preset no formulario (inclusive as curvas)
  public applyPreset(id){
    let preset=null;
    this.presets.forEach(p=>{
      if (p.id==id){
        preset=p;
      }
    })
    if (!preset){
      return;
    }
    //parte de uma copia nova para nao compartilhar referencia com o preset
    let param=JSON.parse(JSON.stringify(preset.param));
    //o preset nao mexe em url/text/closeness/density: isso e da acao
    let current=this.linkForm ? this.linkForm['_value'] : {};
    param.url=this.selectedUrls();
    param.text=current.linkParam!=null ? current.linkParam : (this.lastParam && this.lastParam.text ? this.lastParam.text : '');
    param.closeness=current.closeness!=null ? current.closeness : (this.lastParam ? this.lastParam.closeness : 0);
    param.density=current.density!=null ? current.density : (this.lastParam ? this.lastParam.density : 1);
    //o preset define type/scale das curvas; guardamos para o channel() reusar
    this.lastParam=this.deepMerge(this.lastParam ? this.lastParam : {},param);
    this.loadingForm=true;
    this.linkForm=this.buildForm(this.mergeDefaults(param));
    this.loadCurves();
    this.loadingForm=false;
    this.refreshPresetSelection();
  }
  //marca o preset quando os valores atuais batem com ele; desmarca se o usuario mexeu
  public refreshPresetSelection(){
    let id=this.presetSelect;
    if (!id){
      return;
    }
    let preset=null;
    this.presets.forEach(p=>{
      if (p.id==id){
        preset=p;
      }
    })
    if (!preset){
      return;
    }
    let current=this.presetComparable(this.linkForm ? this.linkForm['_value'] : {});
    let expected=this.presetComparable(preset.param);
    for (let key in expected){
      if (!this.deepEqual(current[key],expected[key])){
        this.presetSelect='';
        return;
      }
    }
  }
  //o linkForm e achatado (rendererType/texture no nivel raiz) enquanto o param tem
  //renderer aninhado. Esta funcao poe os dois no mesmo formato para poder comparar.
  public presetComparable(source){
    let out:any={};
    if (!source){
      return out;
    }
    for (let key in source){
      out[key]=source[key];
    }
    let r=source.renderer;
    if (r && typeof r=='object'){
      out.rendererType=r.rendererType!=null ? r.rendererType : out.rendererType;
      out.blending=r.blending!=null ? r.blending : out.blending;
      out.transparent=r.transparent!=null ? r.transparent : out.transparent;
      out.depthWrite=r.depthWrite!=null ? r.depthWrite : out.depthWrite;
      //textura: no form e um campo direto; no param vem dentro de renderer
      if (r.texture!=null){
        out.texture=r.texture;
      }
      if (r.textureTiles!=null){
        out.textureTiles=r.textureTiles;
      }
    }
    delete out.renderer;
    //no form "sem textura" e '' e no param a chave simplesmente nao existe:
    //normaliza os dois para '' para a comparacao nao falhar so por isso
    if (out.texture==null){
      out.texture='';
    }
    if (out.textureTiles==null){
      out.textureTiles=null;
    }
    return out;
  }
  public deepEqual(a,b){
    if (a===b){
      return true;
    }
    //o input number devolve string; comparamos como numero quando fizer sentido
    if (typeof a=='number' || typeof b=='number'){
      if (a==null || b==null || a==='' || b===''){
        return a===b;
      }
      if (isNaN(Number(a)) || isNaN(Number(b))){
        return a===b;
      }
      return Number(a)===Number(b);
    }
    if (a==null || b==null){
      return a===b;
    }
    if (typeof a!='object' || typeof b!='object'){
      return a===b;
    }
    let aArray=Array.isArray(a);
    let bArray=Array.isArray(b);
    if (aArray!==bArray){
      return false;
    }
    let keysA=Object.keys(a);
    let keysB=Object.keys(b);
    if (keysA.length!=keysB.length){
      return false;
    }
    for (let i=0;i<keysA.length;i++){
      if (!this.deepEqual(a[keysA[i]],b[keysA[i]])){
        return false;
      }
    }
    return true;
  }

  /////////////////////////////////////////////////////////////////////
  // HELPERS NUMERICOS
  /////////////////////////////////////////////////////////////////////
  public clamp(value,min,max,fallback){
    if (value==null || value==='' || isNaN(Number(value))){
      return fallback;
    }
    let n=Number(value);
    if (n<min){return min}
    if (n>max){return max}
    return n;
  }
  public clampUnit(value,fallback){
    return this.clamp(value,0,1,fallback);
  }
  public sanitizeParams(){
    let closeness=this.clamp(this.linkForm.controls['closeness'].value,this.CLOSENESS_MIN,this.CLOSENESS_MAX,0);
    let density=this.clamp(this.linkForm.controls['density'].value,this.DENSITY_MIN,this.DENSITY_MAX,1);
    this.linkForm.patchValue({closeness:closeness,density:density},{emitEvent:false});
    return {closeness:closeness,density:density};
  }

  /////////////////////////////////////////////////////////////////////
  // COR: hex <-> {r,g,b} em 0..1
  /////////////////////////////////////////////////////////////////////
  public componentToHex(v){
    let n=Math.round(this.clampUnit(v,0)*255);
    let hex=n.toString(16);
    return hex.length==1 ? '0'+hex : hex;
  }
  public toHex(rgb){
    let r=this.clampUnit(rgb ? rgb.r : null,1);
    let g=this.clampUnit(rgb ? rgb.g : null,1);
    let b=this.clampUnit(rgb ? rgb.b : null,1);
    return '#'+this.componentToHex(r)+this.componentToHex(g)+this.componentToHex(b);
  }
  public hexToRgb(hex){
    let fallback={r:1,g:1,b:1};
    if (!hex){
      return fallback;
    }
    let value=String(hex).replace('#','').trim();
    if (value.length==3){
      value=value[0]+value[0]+value[1]+value[1]+value[2]+value[2];
    }
    if (value.length!=6 || !/^[0-9a-fA-F]{6}$/.test(value)){
      return fallback;
    }
    return {
      r: Math.round((parseInt(value.substr(0,2),16)/255)*1000)/1000,
      g: Math.round((parseInt(value.substr(2,2),16)/255)*1000)/1000,
      b: Math.round((parseInt(value.substr(4,2),16)/255)*1000)/1000
    };
  }
  public readColor(suffix){
    let group=this.linkForm.get('startColor') as FormGroup;
    if (!group){
      return null;
    }
    let inner=group.get(suffix) as FormGroup;
    let control=inner ? inner.get('color') : null;
    if (!control){
      return null;
    }
    return this.hexToRgb(control.value);
  }

  /////////////////////////////////////////////////////////////////////
  // FORM: pontos de curva (FormArray) <-> lista plana
  /////////////////////////////////////////////////////////////////////
  public buildPointsArray(points){
    let list=(points && points.length>0) ? points : defaultBezierPoints();
    let arr=new FormArray([]);
    list.forEach(p=>{
      arr.push(this.fb.group({
        x: p.x==null ? 0 : p.x,
        y: p.y==null ? 0 : p.y,
        percentage: p.percentage==null ? 0 : p.percentage
      }))
    })
    return arr;
  }
  public buildChannelForm(channel){
    return this.fb.group({
      points: this.buildPointsArray(channel ? channel.bezierPoints : null)
    })
  }
  //acha o FormArray de pontos de um canal, seja colorOverLifetime.r ou sizeOverLifetime.size
  public pointsArray(parent,suffix){
    let group=this.linkForm.get(parent) as FormGroup;
    if (!group){
      return null;
    }
    let inner=group.get(suffix) as FormGroup;
    if (!inner){
      return null;
    }
    let arr=inner.get('points') as FormArray;
    if (arr){
      return arr;
    }
    return null;
  }
  public readPointsArray(arr:FormArray){
    let list=[];
    if (arr){
      arr.controls.forEach(c=>{
        list.push({
          x: Number(c.get('x').value)||0,
          y: c.get('y').value==null || c.get('y').value==='' ? 0 : Number(c.get('y').value),
          percentage: Number(c.get('percentage').value)||0
        })
      })
    }
    if (list.length==0){
      list=defaultBezierPoints();
    }
    return list;
  }
  public readChannelPoints(parent,suffix){
    return this.readPointsArray(this.pointsArray(parent,suffix));
  }
  //copia os pontos do formulario para as propriedades estaveis usadas no template
  public loadCurves(){
    this.colorCurves={
      r: this.readChannelPoints('colorOverLifetime','r'),
      g: this.readChannelPoints('colorOverLifetime','g'),
      b: this.readChannelPoints('colorOverLifetime','b')
    };
    this.sizeCurve=this.readChannelPoints('sizeOverLifetime','size');
    this.opacityCurve=this.readChannelPoints('opacityOverLifetime','opacity');
  }
  //Angular 4 nao tem FormArray.clear(), entao reconstruimos
  public replacePoints(arr:FormArray,points){
    if (!arr){
      return;
    }
    while (arr.length>0){
      arr.removeAt(0);
    }
    (points ? points : []).forEach(p=>{
      arr.push(this.fb.group({
        x: p.x==null ? 0 : p.x,
        y: p.y==null ? 0 : p.y,
        percentage: p.percentage==null ? 0 : p.percentage
      }))
    })
  }
  //chamado pelo <particle-curve> quando os pontos mudam
  public onCurveChange(parent,suffix,points){
    this.replacePoints(this.pointsArray(parent,suffix),points);
    //mantem a referencia estavel em sincronia com o formulario
    if (parent=='colorOverLifetime'){
      this.colorCurves[suffix]=points;
    }
    else if (parent=='sizeOverLifetime'){
      this.sizeCurve=points;
    }
    else if (parent=='opacityOverLifetime'){
      this.opacityCurve=points;
    }
  }

  /////////////////////////////////////////////////////////////////////
  // TEXTURA DO RENDERER
  /////////////////////////////////////////////////////////////////////
  //carrega os icones da sala no formato usado pelo seletor
  public loadRoomIcons(){
    this.roomIcons=[];
    let list=[];
    if (this._appData.room && this._appData.room.textures && this._appData.room.textures.icons){
      list=this._appData.room.textures.icons;
    }
    list.forEach(ic=>{
      if (!ic.id){ic.id=ic.transaction}
      this.roomIcons.push({
        id:ic.id,
        name:ic.name ? ic.name : ic.id,
        url:ic.i2d,
        kind:'icon'
      });
    })
  }
  //o param guarda a textura escolhida via url; a identificacao usa os prefixos do editor
  public textureRef(item){
    return (item && item.kind=='icon') ? 'icon-'+item.id : 'texture-'+item.id;
  }
  public selectTexture(item){
    let url=item.url;
    if (item.kind!='icon' && !url){
      url='assets/particles/textures/'+item.id+'.webp';
    }
    let tiles=item.kind=='icon' ? null : item.tiles;
    this.linkForm.patchValue({texture:url,textureTiles:tiles},{emitEvent:false});
    this.selectedTextureId=this.textureRef(item);
  }
  public clearTexture(){
    this.linkForm.patchValue({texture:'',textureTiles:null},{emitEvent:false});
    this.selectedTextureId='';
  }
  public isTextureSelected(item){
    return this.selectedTextureId==this.textureRef(item);
  }
  //descobre qual item do seletor corresponde a url salva
  public matchTextureId(url){
    if (!url){
      return '';
    }
    let found='';
    this.particleTextures.forEach(t=>{
      if (this.textureUrl(t)==url){
        found='texture-'+t.id;
      }
    })
    if (!found){
      this.roomIcons.forEach(t=>{
        if (t.url==url){
          found='icon-'+t.id;
        }
      })
    }
    return found;
  }
  public textureUrl(item){
    let url=item.url;
    if (item.kind!='icon' && !url){
      url='assets/particles/textures/'+item.id+'.webp';
    }
    return url;
  }

  /////////////////////////////////////////////////////////////////////
  // FORM
  /////////////////////////////////////////////////////////////////////
  public buildForm(param){
    let p=param ? param : defaultParticleParam();
    return this.fb.group({
      //propriedades que ja existiam
      linkParam: p.text!=null ? p.text : '',
      closeness: p.closeness!=null ? p.closeness : 0,
      density: p.density!=null ? p.density : 1,
      //geral
      maxParticles: p.maxParticles!=null ? p.maxParticles : 300,
      duration: p.duration!=null ? p.duration : 5,
      looping: p.looping!=null ? p.looping : true,
      //modulos start
      startLifetime: this.fb.group({
        min: p.startLifetime ? p.startLifetime.min : 0.6,
        max: p.startLifetime ? p.startLifetime.max : 1.4
      }),
      startSpeed: this.fb.group({
        min: p.startSpeed ? p.startSpeed.min : 0.6,
        max: p.startSpeed ? p.startSpeed.max : 1.6
      }),
      startSize: this.fb.group({
        min: p.startSize ? p.startSize.min : 0.5,
        max: p.startSize ? p.startSize.max : 1.1
      }),
      startRotation: this.fb.group({
        min: p.startRotation ? p.startRotation.min : 0,
        max: p.startRotation ? p.startRotation.max : 360
      }),
      startColor: this.fb.group({
        min: this.fb.group({color: this.toHex(p.startColor ? p.startColor.min : null)}),
        max: this.fb.group({color: this.toHex(p.startColor ? p.startColor.max : null)})
      }),
      //modulos over lifetime
      colorOverLifetimeActive: p.colorOverLifetime ? p.colorOverLifetime.isActive : true,
      colorOverLifetime: this.fb.group({
        r: this.buildChannelForm(p.colorOverLifetime ? p.colorOverLifetime.r : null),
        g: this.buildChannelForm(p.colorOverLifetime ? p.colorOverLifetime.g : null),
        b: this.buildChannelForm(p.colorOverLifetime ? p.colorOverLifetime.b : null)
      }),
      sizeOverLifetimeActive: p.sizeOverLifetime ? p.sizeOverLifetime.isActive : true,
      sizeOverLifetime: this.fb.group({
        size: this.buildChannelForm(p.sizeOverLifetime ? p.sizeOverLifetime.size : null)
      }),
      opacityOverLifetimeActive: p.opacityOverLifetime ? p.opacityOverLifetime.isActive : true,
      opacityOverLifetime: this.fb.group({
        opacity: this.buildChannelForm(p.opacityOverLifetime ? p.opacityOverLifetime.opacity : null)
      }),
      //emissao / mundo
      rateOverTime: p.emission ? p.emission.rateOverTime : 90,
      gravity: p.gravity!=null ? p.gravity : 1.2,
      simulationSpace: p.simulationSpace ? p.simulationSpace : 'WORLD',
      //rotacao ao longo da vida
      rotationOverLifetimeActive: p.rotationOverLifetime ? p.rotationOverLifetime.isActive : false,
      angularVelocity: this.fb.group({
        min: p.rotationOverLifetime && p.rotationOverLifetime.angularVelocity ? p.rotationOverLifetime.angularVelocity.min : 0,
        max: p.rotationOverLifetime && p.rotationOverLifetime.angularVelocity ? p.rotationOverLifetime.angularVelocity.max : 0
      }),
      //shape
      shapeShape: p.shape ? p.shape.shape : 'CONE',
      coneAngle: p.shape && p.shape.cone ? p.shape.cone.angle : 0.25,
      coneRadius: p.shape && p.shape.cone ? p.shape.cone.radius : 0.15,
      //noise
      noiseActive: p.noise ? p.noise.isActive : true,
      noiseStrength: p.noise ? p.noise.strength : 0.6,
      noiseFrequency: p.noise ? p.noise.frequency : 1.2,
      noiseScrollSpeed: p.noise ? p.noise.scrollSpeed : 1.5,
      noiseOctaves: p.noise ? p.noise.octaves : 2,
      //renderer
      rendererType: p.renderer ? p.renderer.rendererType : 'INSTANCED',
      blending: p.renderer ? p.renderer.blending : 'additive',
      transparent: p.renderer ? p.renderer.transparent : true,
      depthWrite: p.renderer ? p.renderer.depthWrite : false,
      //textura do renderer: url + tiles (spritesheet), quando houver
      texture: p.renderer && p.renderer.texture ? p.renderer.texture : '',
      textureTiles: p.renderer && p.renderer.textureTiles ? [p.renderer.textureTiles[0],p.renderer.textureTiles[1]] : null
    })
  }

  /////////////////////////////////////////////////////////////////////
  // SERIALIZACAO: monta o param no formato do JSON do motor
  /////////////////////////////////////////////////////////////////////
  public rangeGroup(name,min,max,defMin,defMax){
    let group=this.linkForm.get(name) as FormGroup;
    let minControl=group ? group.get('min') : null;
    let maxControl=group ? group.get('max') : null;
    return {
      min: this.clamp(minControl ? minControl.value : null,min,max,defMin),
      max: this.clamp(maxControl ? maxControl.value : null,min,max,defMax)
    }
  }
  //canal de curva: { type, scale, bezierPoints }; type/scale vem do param salvo
  public channel(parent,suffix){
    let original=(this.lastParam && this.lastParam[parent] && this.lastParam[parent][suffix]) ? this.lastParam[parent][suffix] : null;
    return {
      type: (original && original.type) ? original.type : 'BEZIER',
      scale: (original && original.scale!=null) ? original.scale : 1,
      bezierPoints: this.readChannelPoints(parent,suffix)
    }
  }
  public selectedUrls(){
    let urls=[]
    if (this.itemVideos){
      for (let i = 0; i < this.itemVideos.length; i++) {
        if (this.itemVideos[i].selected) {
          urls.push(this.itemVideos[i].id)
        }
      }
    }
    return urls;
  }
  public buildParam(){
    let v=this.linkForm['_value'];
    let param:any={
      //propriedades que ja existiam
      url: this.selectedUrls(),
      text: v.linkParam!=null ? v.linkParam : '',
      closeness: this.clamp(v.closeness,this.CLOSENESS_MIN,this.CLOSENESS_MAX,0),
      density: this.clamp(v.density,this.DENSITY_MIN,this.DENSITY_MAX,1),

      maxParticles: Math.round(this.clamp(v.maxParticles,this.MAX_PARTICLES_MIN,this.MAX_PARTICLES_MAX,300)),
      duration: this.clamp(v.duration,this.DURATION_MIN,this.DURATION_MAX,5),
      looping: v.looping ? true : false,

      startLifetime: this.rangeGroup('startLifetime',this.LIFETIME_MIN,this.LIFETIME_MAX,0.6,1.4),
      startSpeed: this.rangeGroup('startSpeed',this.SPEED_MIN,this.SPEED_MAX,0.6,1.6),
      startSize: this.rangeGroup('startSize',this.SIZE_MIN,this.SIZE_MAX,0.5,1.1),
      startRotation: this.rangeGroup('startRotation',this.ANGLE_MIN,this.ANGLE_MAX,0,360),

      startColor: {
        min: this.readColor('min'),
        max: this.readColor('max')
      },

      colorOverLifetime: {
        isActive: v.colorOverLifetimeActive ? true : false,
        r: this.channel('colorOverLifetime','r'),
        g: this.channel('colorOverLifetime','g'),
        b: this.channel('colorOverLifetime','b')
      },
      sizeOverLifetime: {
        isActive: v.sizeOverLifetimeActive ? true : false,
        size: this.channel('sizeOverLifetime','size')
      },
      opacityOverLifetime: {
        isActive: v.opacityOverLifetimeActive ? true : false,
        opacity: this.channel('opacityOverLifetime','opacity')
      },

      emission: {
        rateOverTime: this.clamp(v.rateOverTime,this.RATE_MIN,this.RATE_MAX,90)
      },
      gravity: this.clamp(v.gravity,this.GRAVITY_MIN,this.GRAVITY_MAX,1.2),
      simulationSpace: v.simulationSpace ? v.simulationSpace : 'WORLD',

      rotationOverLifetime: {
        isActive: v.rotationOverLifetimeActive ? true : false,
        angularVelocity: this.rangeGroup('angularVelocity',this.ANGULAR_VELOCITY_MIN,this.ANGULAR_VELOCITY_MAX,0,0)
      },

      shape: {
        shape: v.shapeShape ? v.shapeShape : 'CONE',
        cone: {
          angle: this.clamp(v.coneAngle,this.CONE_ANGLE_MIN,this.CONE_ANGLE_MAX,0.25),
          radius: this.clamp(v.coneRadius,this.RADIUS_MIN,this.RADIUS_MAX,0.15)
        }
      },

      noise: {
        isActive: v.noiseActive ? true : false,
        strength: this.clamp(v.noiseStrength,this.NOISE_STRENGTH_MIN,this.NOISE_STRENGTH_MAX,0.6),
        frequency: this.clamp(v.noiseFrequency,this.NOISE_FREQUENCY_MIN,this.NOISE_FREQUENCY_MAX,1.2),
        scrollSpeed: this.clamp(v.noiseScrollSpeed,this.SCROLL_SPEED_MIN,this.SCROLL_SPEED_MAX,1.5),
        octaves: Math.round(this.clamp(v.noiseOctaves,this.OCTAVES_MIN,this.OCTAVES_MAX,2))
      },

      renderer: {
        rendererType: v.rendererType ? v.rendererType : 'INSTANCED',
        blending: v.blending ? v.blending : 'additive',
        transparent: v.transparent ? true : false,
        depthWrite: v.depthWrite ? true : false
      }
    };
    //textura do renderer: so aparece no param quando escolhida
    if (v.texture){
      param.renderer.texture=v.texture;
    }
    if (v.textureTiles && v.textureTiles.length==2){
      param.renderer.textureTiles=[Number(v.textureTiles[0]),Number(v.textureTiles[1])];
    }
    return param;
  }
  /////////////////////////////////////////////////////////////////////
  // GRAVACAO
  /////////////////////////////////////////////////////////////////////
  public processData(action){
    if (!action){
      action={kind:'particles',param:{}}
    }
    if (!action.param){
      action.param={}
    }
    let savedParam=this._appData.action.param ? this._appData.action.param : {};
    this.sanitizeParams();
    let param=this.mergeExtra(this.buildParam(),savedParam);
    this._appData.action.param=param;
    if (this._appData.activeTrigger=='onClose'){
      this._appData.object.kind='particle'
    }
  }
  //preserva o que o editor nao cobre (type/scale das curvas, chaves de shape do motor)
  public mergeExtra(built,saved){
    if (!saved){
      return built;
    }
    ['colorOverLifetime','sizeOverLifetime','opacityOverLifetime'].forEach(section=>{
      ['r','g','b','size','opacity'].forEach(suffix=>{
        if (saved[section] && saved[section][suffix] && built[section] && built[section][suffix]){
          if (saved[section][suffix].type){
            built[section][suffix].type=saved[section][suffix].type;
          }
          if (saved[section][suffix].scale!=null){
            built[section][suffix].scale=saved[section][suffix].scale;
          }
        }
      })
    })
    if (saved.shape && built.shape){
      Object.keys(saved.shape).forEach(k=>{
        if (built.shape[k]==null){
          built.shape[k]=saved.shape[k];
        }
      })
    }
    //qualquer chave de topo ou de sub-objeto que o editor nao conhece e preservada
    this.keepUnknownKeys(built,saved);
    return built;
  }
  public keepUnknownKeys(built,saved){
    Object.keys(saved).forEach(k=>{
      if (built[k]===undefined){
        built[k]=saved[k];
        return;
      }
      let b=built[k];
      let s=saved[k];
      if (b && s && typeof b=='object' && !Array.isArray(b) && typeof s=='object' && !Array.isArray(s)){
        Object.keys(s).forEach(sub=>{
          if (b[sub]===undefined){
            b[sub]=s[sub];
          }
        })
      }
    })
  }

  public selectItemImage(thumbnail) {
    this.media=null
    for (let i = 0; i < this.itemVideos.length; i++) {
      if (this.itemVideos[i].id == thumbnail.id) {
        if (this.itemVideos[i].selected){
          this.itemVideos[i].selected = false;
        }
        else{
          this.itemVideos[i].selected = true;
        }
      }
    }



  }  
  public childrenReloadData(){

    this.reloadLocalPacks();

  

  }
  public reloadLocalPacks(){
    let action = this._appData.action;
    let trigger=this._appData.activeTrigger;
    let saved=action.param ? action.param : {};
    this.lastParam=saved;
    this.presetSelect='';
    //reconstroi o form; chaves ausentes (particles antigos) caem nos defaults
    this.loadingForm=true;
    this.linkForm=this.buildForm(this.mergeDefaults(saved));
    this.loadCurves();
    this.loadingForm=false;
    //textura do renderer: descobre qual item do seletor corresponde a url salva
    this.loadRoomIcons();
    this.selectedTextureId=this.matchTextureId(saved.renderer ? saved.renderer.texture : '');
    if (trigger=='onClick'){
      //preciso permitir botar texto
      this.onClickAction=true
    }

    if (!this.selectedPack){
      if (this._appData.room.textures.icons) {
        this.itemVideos = []
        this._appData.room.textures.icons.forEach(ic => {
          let text={id:'texture-'+ic.id,url:ic.i2d,selected:false}
          if (action.param) {
            if (action.param.url) {
              action.param.url.forEach(u=>{
                if (u==text.id){
                  text.selected = true;
                }
              })
  
            }
            this.itemVideos.push(text);
          }
      })
     }
        
    }
    else{
      if (this.selectedPack.icons) {
        this.itemVideos = []
        this.selectedPack.icons.forEach(ic => {
          let text={id:'pack-'+this.selectedPack.id+'-id-'+ic.id,url:ic.i2d,selected:false}
          if (action.param) {
            if (action.param.url) {
              action.param.url.forEach(u=>{
                if (u==text.id){
                  text.selected = true;
                }
              })
  
            }
            this.itemVideos.push(text);
          }
      })
     }
    }
  }
  //completa o param salvo com os defaults (para particles gravados antes destes campos)
  public mergeDefaults(saved){
    let base=defaultParticleParam();
    if (!saved){
      return base;
    }
    return this.deepMerge(base,saved);
  }
  public deepMerge(base,saved){
    let out:any={};
    Object.keys(base).forEach(k=>{
      if (saved[k]==null){
        out[k]=base[k];
      }
      else if (typeof base[k]=='object' && !Array.isArray(base[k]) && typeof saved[k]=='object'){
        out[k]=this.deepMerge(base[k],saved[k]);
      }
      else{
        out[k]=saved[k];
      }
    })
    //mantem chaves que existem so no salvo
    Object.keys(saved).forEach(k=>{
      if (out[k]==null){
        out[k]=saved[k];
      }
    })
    return out;
  }
    public ngOnInit(): any {


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/particles.ts